import 'css-chunksrc/client/scenes/moveElement/projectsSelection/scrollPane/styles.scss';export default {
  "scrollPane": "_scrollPane_izetc_1"
};